function Experience(){
return(
<section className="card-flex">
<h2>Experiência / Estudos</h2>

<div className="card">
<h3>Bacharelado em Engenharia de Software</h3>
<h4>Instituição: UFBRA</h4>
<p>Atualmente no 2º período.</p>
</div>
<div className="card">
<h3>Desenvolverdor Fullstack</h3>
<h4>Instituição: Cubos Academy</h4>
<p>Formado em 2023.</p>
</div>

</section>
)
}

export default Experience
